module.exports = __webpack_public_path__ + "static/media/students progress report.1fab1906.svg";